import classes from './ExternalBadge.module.css';

export const ExternalBadge = () => {
    return (
        <span className={classes['circle']}>
            <span className={classes['text']}>E</span>
        </span>
    );
};
